import { FunctionComponent, ChangeEvent } from 'react';
import { DateAndTimeTemplate } from '@templates';
import { TextInputMolecule } from '@molecules/*';

export interface DateTimeFieldsProps {
  dateLabel: string;
  dateDescription: string;
  dateErrorPath: string;
  dateErrorMessages: any;
  day: string;
  month: string;
  year: string;
  onChangeDay: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeMonth: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeYear: (e: ChangeEvent<HTMLInputElement>) => void;

  timeLabel: string;
  timeDescription: string;
  timeErrorPath: string;
  timeErrorMessages: any;
  hour: string;
  minute: string;
  onChangeHour: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeMinute: (e: ChangeEvent<HTMLInputElement>) => void;
}

const renderTextInput = (
  label: string,
  name: string,
  value: string,
  errorPath: string,
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  maxLength: number,
  widthClass: string,
) => (
  <section className={widthClass}>
    <TextInputMolecule
      maxLength={maxLength}
      label={label}
      name={name}
      errorPath={errorPath}
      value={value}
      onChange={onChange}
      aria-label={`Enter ${label.toLowerCase()}`}
    />
  </section>
);

export const DateTimeFields: FunctionComponent<DateTimeFieldsProps> = ({
  dateLabel,
  dateDescription,
  dateErrorPath,
  dateErrorMessages,
  day,
  month,
  year,
  onChangeDay = () => {},
  onChangeMonth = () => {},
  onChangeYear = () => {},

  timeLabel,
  timeDescription,
  timeErrorPath,
  timeErrorMessages,
  hour,
  minute,
  onChangeHour = () => {},
  onChangeMinute = () => {},
}) => {
  return (
    <>
      <DateAndTimeTemplate
        labelText={dateLabel}
        description={dateDescription}
        children={
          <div className="flex gap-x-4">
            {renderTextInput(
              'Day',
              'selectedDay',
              day,
              'dayRange',
              onChangeDay,
              2,
              'w-12',
            )}
            {renderTextInput(
              'Month',
              'selectedMonth',
              month,
              'monthRange',
              onChangeMonth,
              2,
              'w-12',
            )}
            {renderTextInput(
              'Year',
              'selectedYear',
              year,
              'yearRange',
              onChangeYear,
              4,
              'w-16',
            )}
          </div>
        }
        errorPath={dateErrorPath}
        errorMessages={dateErrorMessages}
      />

      <DateAndTimeTemplate
        labelText={timeLabel}
        description={timeDescription}
        children={
          <section className="flex gap-x-6">
            {renderTextInput(
              'Hours',
              'selectedHour',
              hour,
              'hourRange',
              onChangeHour,
              2,
              'w-12',
            )}
            {renderTextInput(
              'Minute',
              'selectedMinute',
              minute,
              'minuteRange',
              onChangeMinute,
              2,
              'w-12',
            )}
          </section>
        }
        errorPath={timeErrorPath}
        errorMessages={timeErrorMessages}
      />
    </>
  );
};
